/**
 * Collection PLP UI: view toggle + filter drawer shell (filters/search not applied yet).
 */
(function () {
  function initPlp(root) {
    if (!root || root.dataset.plpReady === 'true') return;
    root.dataset.plpReady = 'true';

    var grid = root.querySelector('[data-plp-grid]');
    var viewButtons = root.querySelectorAll('[data-plp-view]');
    var openButtons = root.querySelectorAll('[data-plp-filters-open]');
    var closeButtons = root.querySelectorAll('[data-plp-filters-close]');
    var drawer = root.querySelector('[data-plp-drawer]');
    var overlay = root.querySelector('[data-plp-drawer-overlay]');

    function setView(view) {
      if (!grid) return;
      grid.dataset.view = view;
      viewButtons.forEach(function (btn) {
        var active = btn.getAttribute('data-plp-view') === view;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    viewButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setView(btn.getAttribute('data-plp-view') || 'grid');
      });
    });

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) {
        overlay.classList.add('is-open');
        overlay.hidden = false;
      }
      document.documentElement.classList.add('qt-plp-drawer-open');
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) {
        overlay.classList.remove('is-open');
        overlay.hidden = true;
      }
      document.documentElement.classList.remove('qt-plp-drawer-open');
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });
    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });
    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-qt-plp]').forEach(initPlp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('[data-qt-plp]')
      : null;
    if (section) {
      section.dataset.plpReady = 'false';
      initPlp(section);
    }
  });
})();
